import AccessOffering from 'organisms/Modals/AccessOffering';
import React, { useMemo, useState } from 'react';
import { navigateToAuthUrl } from 'utils/authUtils';
import { IOfferingInfo } from 'utils/globalTypes';
import { useUserAuth } from 'utils/hooks/useUserAuth';
import { getOfferingUrl } from 'utils/navigateUtils';

export const useBlockedAction = (offering?: IOfferingInfo) => {
  const authDetails = useUserAuth();

  const [showModal, setShowModal] = useState<boolean>(false);

  const onRequestAccess = async () => {
    setShowModal(true);
  };

  const onNavigateAuth = () => {
    return navigateToAuthUrl({
      isAuthenticated: authDetails?.isAuthenticated,
      redirectUrl: getOfferingUrl(offering?.offering_id)
    });
  };

  const onBlockedAction = () => {
    return !authDetails?.isAuthenticated || !authDetails.kycDone || !authDetails.investorAccredited
      ? onNavigateAuth()
      : onRequestAccess();
  };

  const blockedActionTitle = authDetails?.isAuthenticated
    ? !authDetails.kycDone
      ? 'Complete registration'
      : !authDetails.investorAccredited
      ? 'Update my details'
      : 'Request access'
    : 'Sign Up';

  const blockedPrimaryTitle = authDetails?.isAuthenticated
    ? !authDetails.kycDone || !authDetails.investorAccredited
      ? 'Sign up to view offerings'
      : 'Request access to view offering'
    : 'Complete registration to get access';

  const requestAccessModal = useMemo(
    () => (
      <AccessOffering offering={offering} open={showModal} onClose={() => setShowModal(false)} />
    ),
    [showModal]
  );

  return {
    blockedActionTitle,
    blockedPrimaryTitle,
    onRequestAccess,
    onNavigateAuth,
    requestAccessModal,
    onBlockedAction
  };
};
